import React from 'react';
import PropTypes from 'prop-types';
import FontIcon from 'components/FontIcon';
import classes from './CardIconE.module.scss';

const CardIconE = (props) => {
  const {
    heading,
    icon,
    contentMarkup,
  } = props;

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        {icon &&
          <div className={classes.iconWrapper}>
            <FontIcon icon={icon} className={classes.icon} />
          </div>}
        {heading &&
        <h2
          className={classes.heading}
          dangerouslySetInnerHTML={{ __html: heading }}
        />}
      </div>
      {contentMarkup &&
        <div
          className={classes.contentMarkup}
          dangerouslySetInnerHTML={{ __html: contentMarkup }}
        />}
    </div>
  );
};

CardIconE.propTypes = {
  /**
   * Heading of the card
  */
  heading: PropTypes.string,
  /**
   * Icon of the card
  */
  icon: PropTypes.string,
  /**
   * HTML content of the card
  */
  contentMarkup: PropTypes.string,
};

export default CardIconE;
